<template>
  <div class="home">
    <div>
      <el-watermark :font="font" :content="['阿伟专用']">
        <TemplateReport :height="reportHeight" ></TemplateReport>
      </el-watermark>
    </div>
  </div>
</template>

<script setup>
import TemplateReport from '@/components/template/TemplateReport.vue';
import { reactive, ref, onMounted, onUnmounted } from 'vue'

const font = reactive({
  color: 'rgba(0, 0, 0, .15)',
})

const reportHeight = ref(600)

function calculateHeight() {
  const windowHeight = window.innerHeight
  // 总高度 - Header(60px) - Footer(30px) 
  reportHeight.value = windowHeight - 90
}

onMounted(() => {
  calculateHeight()
  window.addEventListener('resize', calculateHeight)
})

onUnmounted(() => {
  window.removeEventListener('resize', calculateHeight)
})
</script>

<style scoped>
.home {
  width: 100%;
  margin-top: 0px;
}
</style>
